import { memo } from 'react';

import { Typography } from '@mui/material';

import { formatDateTime } from '@/shared/lib/format';

import { DATE_NUMBER_CELL_SX } from './cells.styles';

export interface DateTimeCellProps {
  value: string | Date | null | undefined;
}

export const DateTimeCell = memo(({ value }: DateTimeCellProps) => (
  <Typography variant="body2" sx={DATE_NUMBER_CELL_SX}>
    {formatDateTime(value)}
  </Typography>
));
DateTimeCell.displayName = 'DateTimeCell';
